function getActiveSession() {
  let getSession = window.sessionStorage.getItem("session_type");
  return getSession;
}

function switchSession(session) {
  window.sessionStorage.setItem("session_type", session);
}

function setCurrentNavToggle() {
  let navSwitch = document.getElementById("main-nav-toggle");
  let session = getActiveSession();
  if (navSwitch != undefined && session != null) {
    removeActoveFromNav();
    navSwitch.querySelector(`#${session}`).classList.add("nav-toggle-active");

    setActiveImage();
  }
}

setCurrentNavToggle();

function navInitState() {
  let session = getActiveSession();
  if (session == null || session == "") {
    //Check what link is selected
    const switchBar = document.getElementById("nav-switch-bar");
    let currentActiveToggle = switchBar.querySelector(".nav-toggle-active");
    switchSession(
      currentActiveToggle != null ? currentActiveToggle.id : "adee"
    );
  }
}
navInitState();

function removeActoveFromNav() {
  let navSwitch = document.getElementById("main-nav-toggle");
  if (navSwitch != undefined) {
    let navItems = navSwitch.querySelectorAll(".nav-toggle-item");
    navItems.forEach((item) => {
      item.classList.remove("nav-toggle-active");
    });
  }
}

function displayCurrentNavigation() {
  let session = getActiveSession();

  let navigations = document.querySelectorAll(".site-header__wrapper");
  navigations.forEach((stickyNav) => {
    let navigationElement = stickyNav.querySelector("site-header");

    if (navigationElement.id == `navigation-type-${session}`) {
      stickyNav.parentElement.style.display = "block";
    } else {
      stickyNav.parentElement.style.display = "none";
    }
  });
}
displayCurrentNavigation();

function setActiveImage() {
  let session = getActiveSession();
  let navSwitch = document.getElementById("main-nav-toggle");
  if (navSwitch != undefined) {
    let navItems = navSwitch.querySelectorAll(".nav-toggle-item");
    navItems.forEach((item) => {
      if (item.id == session && item.querySelector(".active-image") != null) {
        item.querySelector(".section-image").style.display = "none";
        item.querySelector(".active-image").classList.remove("hidden-element");
      } else if (item.querySelector(".active-image") != null) {
        item.querySelector(".section-image").style.display = "block";
        item.querySelector(".active-image").classList.add("hidden-element");
      }
    });
  }
}
